import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, Heart, Zap } from 'lucide-react';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    {
      title: 'Product',
      links: [
        { label: 'Home', path: '/' },
        { label: 'How to Use', path: '/how-to-use' },
        { label: 'Demo', path: '/demo' },
        { label: 'About Us', path: '/about' },
      ]
    },
    {
      title: 'Legal',
      links: [
        { label: 'Privacy Policy', path: '/privacy' },
        { label: 'Terms of Service', path: '/terms' },
        { label: 'Cookie Policy', path: '/cookies' },
        { label: 'GDPR', path: '/gdpr' },
      ]
    },
    {
      title: 'Support',
      links: [
        { label: 'Contact', path: '/contact' },
        { label: 'FAQ', path: '/faq' },
      ]
    }
  ];

  return (
    <footer className="bg-white border-t mt-auto">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-8">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center space-x-2 mb-4">
              <BookOpen className="w-8 h-8 text-purple-600" />
              <span className="font-bold text-xl">Spell Jam</span>
            </Link>
            <p className="text-gray-600 text-sm mb-4">
              Making spelling practice fun and effective for students worldwide.
            </p>
            
            {/* Built with Bolt.new Badge */}
            <a
              href="https://bolt.new"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-3 py-2 bg-gradient-to-r from-purple-600 to-blue-600 text-white text-sm rounded-full hover:opacity-90 transition-opacity group"
            >
              <Zap className="w-4 h-4 group-hover:scale-110 transition-transform" />
              <span className="font-medium">Built with Bolt.new</span>
            </a>
          </div>

          {footerLinks.map((section) => (
            <div key={section.title}>
              <h3 className="font-semibold text-gray-800 mb-4">{section.title}</h3>
              <ul className="space-y-2">
                {section.links.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-gray-600 hover:text-purple-600 text-sm"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-sm text-gray-600">
              © {currentYear} Spell Jam. All rights reserved.
            </div>
            <div className="flex items-center gap-2 text-sm text-gray-600">
              <span>Developed with</span>
              <Heart className="w-4 h-4 text-red-500 fill-current" />
              <span>by</span>
              <a
                href="https://www.brandfinesse.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-purple-600 hover:text-purple-700 font-medium"
              >
                BrandFinesse
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}